import { PlaceholderBrandmark, PlaceholderLogo } from './images';
import { TenantAsset } from './TenantAsset';
import { TenantBrandAssets } from './TenantBrandAssets';

// Neutral, brand-agnostic fallbacks. Every tenant overrides these via its own
// BRAND_ASSETS, so these only render if a tenant provides none.
export const CORE_BRAND_ASSETS: TenantBrandAssets = {
  [TenantAsset.LogoHorizontalDark]: PlaceholderLogo,
  [TenantAsset.LogoHorizontalLight]: PlaceholderLogo,
  [TenantAsset.BrandmarkDark]: PlaceholderBrandmark,
  [TenantAsset.BrandmarkLight]: PlaceholderBrandmark,
};
